import { createAsyncThunk } from '@reduxjs/toolkit';
import { checkFreeTrialAvailability } from '../apis/free-trial.api';
import { CheckFreeTrialAvailabilityParams } from '../interfaces/free-trial-availability.interface';
import { StoreState } from '../../../store/store.interface';
import { ActionStatus } from '../../../common/constants/action-status';

export const getFreeTrialAvailability = createAsyncThunk(
  'freeTrial/checkAvailability',
  async (params: CheckFreeTrialAvailabilityParams, thunkAPI) => {
    try {
      return await checkFreeTrialAvailability(params.skus);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
  {
    condition: (_: CheckFreeTrialAvailabilityParams, { getState }) => {
      const state = getState() as StoreState;
      return ActionStatus.idle === state.freeTrialState.freeTrialAvailability.status;
    },
  }
);
